import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { HttpClient, HttpResponse } from '@angular/common/http';

// ** rxjs
import { Observable, of } from 'rxjs';
import { tap, catchError, map } from 'rxjs/operators';

// ** env
import { config } from '@app/core/app.config';

// ** service
import { ErrorCatchService } from './errorCatch.service';

@Injectable({
	providedIn: 'root',
})
export class AboutService {
	constructor(
		private http: HttpClient,
		private router: Router,
		private httpClient: HttpClient,
		private errorCatchService: ErrorCatchService
	) {}

	getMilestones(): Observable<any> {
		const fileName = 'milestone.json';
		return this.httpClient.get(`${config.about}/${fileName}`).pipe(
			map((res) => res),
			catchError(this.errorCatchService.handler)
		);
	}
}
